import { render, staticRenderFns } from "./AgentMessage.vue?vue&type=template&id=5f0b196a&scoped=true"
import script from "./AgentMessage.vue?vue&type=script&lang=js"
export * from "./AgentMessage.vue?vue&type=script&lang=js"
import style0 from "./AgentMessage.vue?vue&type=style&index=0&id=5f0b196a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f0b196a",
  null
  
)

export default component.exports